module.exports = __webpack_public_path__ + "img/advantage.90155645.png";